import Alert from "@mui/material/Alert";

import styles from "./CustomFieldRemovedColumnsAlert.module.css";
import type { CustomFieldRemovedColumnsAlertState } from "./useCustomFieldGridIntegration";

/**
 * Dismissible warning naming the since-deleted custom fields whose columns a
 * grid auto-pruned from the user's stored preferences. Renders nothing once
 * dismissed or when no fields were removed. Fed the `removedColumnsAlert` state
 * from `useCustomFieldGridIntegration`.
 */
export function CustomFieldRemovedColumnsAlert({
  fieldNames,
  dismissed,
  dismiss,
}: CustomFieldRemovedColumnsAlertState) {
  if (dismissed || fieldNames.length === 0) {
    return null;
  }
  const message =
    fieldNames.length === 1
      ? `The custom field "${fieldNames[0]}" was deleted, so its column was removed from your table.`
      : `These custom fields were deleted, so their columns were removed from your table: ${fieldNames.join(", ")}.`;

  return (
    <Alert severity="warning" onClose={dismiss} className={styles.alert}>
      {message}
    </Alert>
  );
}
